/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function CodeObject({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 12" {...props}><path fill="currentColor" d="M2.25 1.05a1.2 1.2 0 0 0-1.2 1.2v2.69a.3.3 0 0 1-.088.211l-.53.53a.45.45 0 0 0 0 .637l.53.53a.3.3 0 0 1 .088.212v2.69a1.2 1.2 0 0 0 1.2 1.2H3a.45.45 0 0 0 0-.9h-.75a.3.3 0 0 1-.3-.3V7.06a1.2 1.2 0 0 0-.352-.848L1.386 6l.212-.212a1.2 1.2 0 0 0 .352-.849V2.25a.3.3 0 0 1 .3-.3H3a.45.45 0 1 0 0-.9h-.75ZM9 1.95h.75a.3.3 0 0 1 .3.3v2.69c0 .317.126.623.351.848l.212.212-.212.212a1.2 1.2 0 0 0-.351.848v2.69a.3.3 0 0 1-.3.3H9a.45.45 0 0 0 0 .9h.75a1.2 1.2 0 0 0 1.2-1.2V7.06a.3.3 0 0 1 .088-.212l.53-.53a.45.45 0 0 0 0-.636l-.53-.53a.3.3 0 0 1-.088-.213V2.25a1.2 1.2 0 0 0-1.2-1.2H9a.45.45 0 0 0 0 .9Z" /><path fill="currentColor" d="M3.375 5.325a.675.675 0 1 1 0 1.35.675.675 0 0 1 0-1.35ZM6 5.325a.675.675 0 1 1 0 1.35.675.675 0 0 1 0-1.35ZM8.625 5.325a.675.675 0 1 1 0 1.35.675.675 0 0 1 0-1.35Z" /></svg>;
}
;